module.exports = __webpack_public_path__ + "static/13-741152fc7c7a5357ecc6cc89a533603f.png";